<template>
    <div>
        <img
            class="image-thumb"
            v-for="(photo, index) in photos"
            :key="index"
            :src="$filters.baseurl(photo.url)"
            @click="show"
        />
    </div>

    <teleport to="body">
        <vue-easy-lightbox
            :imgs="imgSrcs"
            :visible="lightboxVisible"
            @hide="() => lightboxVisible = false"
        />
    </teleport>
</template>
<script lang="ts">
import { Prop } from '@/helpers/Decorators';
import { Resource as FileResource } from '@/modules/core/files/services/StorageService';
import { Vue, Options } from 'vue-class-component';
import VueEasyLightbox from 'vue-easy-lightbox';

@Options({
    components: { VueEasyLightbox }
})
export default class MessagePhotos extends Vue
{
    @Prop() public photos: FileResource[];

    public lightboxVisible: boolean = false;
    public imgSrcs: string[] = [];

    public show(): void
    {
        this.imgSrcs = this.photos.map(photo => this.$filters.baseurl(photo.url));
        this.lightboxVisible = true;
    }
}
</script>
<style lang="scss" scoped>
div{
    display: flex;
    gap: 5px;
    img.image-thumb{
        width: 50px;
        height: 50px;
        object-fit: cover;
        cursor: pointer;
    }
}
</style>